import styled from 'styled-components'

import { Action } from '../styles/mixins'
import { StyledStatusBadge } from './bootstrap/StyledStatusBadge'

export const RejectedBadge = styled(StyledStatusBadge)`
  ${Action({
    background: 'var(--badge-color-inactive) !important',
    color: 'var(--font-color-light) !important',
  })}
`
